import { memo, FC } from 'react';

interface ErrorProps {
  message: string;
}
export const Error: FC<ErrorProps> = memo(({ message }) => {
  return <div className="text-danger">{message}</div>;
});
